import React, { useState, useRef, useEffect } from 'react'
import './index.css'
import ReactToPrint from 'react-to-print'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import wisc4Icon1 from '../../../../../assets/SarbargWisc4-1.png'
import wisc4Icon2 from '../../../../../assets/SarbargWisc4-2.png'
const faScoboQuestions = require('../../../../../utils/scoboTestQuestionsFa.js')
const faGars2Questions = require('../../../../../utils/gars2TestQuestionsFa.js')
const faGars3Questions = require('../../../../../utils/gars3TestQuestionsFa.js')
const faNumbers = require('../../../../../utils/numbersFa.js')

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function ResultModalWisc4({ evaluation, closeModal, testStats, clinicName }) {

    const [testName, setTestName] = useState(evaluation.Session)
    const [testIndex, setTestIndex] = useState(evaluation.Index)
    const [testAnswer, setTestAnswer] = useState(evaluation.Answers)
    const [testQuestion, setTestQuestion] = useState(evaluation.Questions)
    const [testSubscales, setTestSubscales] = useState(evaluation.Subscales)
    const [testPercentiles, setTestPercentiles] = useState(evaluation.Percentiles)
    const [testStartDate, setTestStartDate] = useState(evaluation.StartDate)
    const [testStartDateDay, setTestStartDateDay] = useState(new Date(evaluation.StartDate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(8,10))
    const [testStartDateMonth, setTestStartDateMonth] = useState(new Date(evaluation.StartDate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(5,7))
    const [testStartDateYear, setTestStartDateYear] = useState(new Date(evaluation.StartDate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(0,4))
    const [examinerName, setExaminerName] = useState(evaluation.Examiner)
    const [resultAds, setResultAds] = useState(evaluation.Result)
    const [score, setScore] = useState(evaluation.Score)
    const [name, setName] = useState(testStats.firstname)
    const [lName, setLName] = useState(testStats.lastname)
    const [birthResult, setBirthResult] = useState(testStats.birthdate)
    const [birthDay, setBirthDay] = useState(new Date(testStats.birthdate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(8,10))
    const [birthMonth, setBirthMonth] = useState(new Date(testStats.birthdate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(5,7))
    const [birthYear, setBirthYear] = useState(new Date(testStats.birthdate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(0,4))
    const [clinic, setClinic] = useState(clinicName)
    const [adsResults, setAdsResults] = useState([])
    const [ageDay, setAgeDay] = useState(0)
    const [ageMonth, setAgeMonth] = useState(0)
    const [ageYear, setAgeYear] = useState(0)
    const farsiNumbers = faNumbers

    const COLORS = ['#0088FE', '#D70040'];

    const chartAreaBorder = {
        id: 'chartAreaBorder',
        beforeDraw(chart, args, options) {
            const {ctx, chartArea: {left, top, width, height}} = chart;
            ctx.save();
            ctx.strokeStyle = options.borderColor;
            ctx.lineWidth = options.borderWidth;
            ctx.setLineDash(options.borderDash || []);
            ctx.lineDashOffset = options.borderDashOffset;
            ctx.strokeRect(left, top, width, height);
            ctx.restore();
        }
    };

    const options1 = {
        responsive: true,
        maintainAspectRatio: true,
        
        plugins: {
            legend: {
                display: false,
                
            },
            chartAreaBorder: {
                borderColor: 'black', // borderColor: 'red',
                borderWidth: 2,
                // borderDash: [5, 5],
                // borderDashOffset: 2,
            }
        },
        scales: {
            y: {
              suggestedMin: 1,
              
              suggestedMax: 19,

              grid: {
                display: false,
              },
              ticks: {
                font: {
                    size:10
                }
              }
            },
            x: {
              ticks: {
                display: false,
              },
              offset: true,
            }
          }
    };
    
    const options = {
        responsive: true,
        maintainAspectRatio: true,
        // layout: {
        //     padding: {
        //         right: 30,
        //     }
        // },
        plugins: {
            legend: {
                display: false,
                // position: 'top',
            },
            // title: {
            //     display: true,
            //     text: 'پروفایل نمرات هوشبهرها'
            // },
            chartAreaBorder: {
                borderColor: 'black', // borderColor: 'red',
                borderWidth: 2,
                // borderDash: [5, 5],
                // borderDashOffset: 2,
            }
        },
        scales: {
            y: {
              // the data minimum used for determining the ticks is Math.min(dataMin, suggestedMin)
              suggestedMin: 40,
      
              // the data maximum used for determining the ticks is Math.max(dataMax, suggestedMax)
              suggestedMax: 160,

              grid: {
                display: false,
              },
              ticks: {
                font: {
                    size:10
                }
              }
            },
            x: {
              ticks: {
                display: false,
              },
              offset: true,
            }
          }
    };
    
    const labels1 = ['S', 'V', 'C', '(I)', '(Ad)', 'CC', 'Co', 'M', '(CF)', 'RD', 'LN', '(Ar)', 'CI', 'BS', '(A)'];

    const labels2 = ['VCI', 'PRI', 'WMI', 'PSI', 'FSIQ'];

    const data1 = {
        labels: labels1,
        datasets: [
          {
            label: 'نمرات',
            data: [testPercentiles[0], testPercentiles[1], testPercentiles[2], testPercentiles[3], testPercentiles[4], testPercentiles[5], testPercentiles[6], testPercentiles[7], testPercentiles[8], testPercentiles[9], testPercentiles[10], testPercentiles[11], testPercentiles[12], testPercentiles[13], testPercentiles[14]],
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          },
        ],
    };
    
    const data = {
        labels: labels2,
        datasets: [
          {
            label: 'هوشبهر',
            data: [testSubscales[0], testSubscales[1], testSubscales[2], testSubscales[3], testSubscales[4]],
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          },
        ],
    };

    const userPercentileText = 
    [
        "طراحی با بلوک‌ها",
        "شباهت‌ها",
        "فراخنای ارقام",
        "مفاهیم تصویری",
        "رمزنویسی",
        "واژگان",
        "توالی حرف و عدد",
        "استدلال تصویری",
        "درک مطلب",
        "نمادیابی",
        "تکمیل تصاویر",
        "خط‌زنی",
        "اطلاعات عمومی",
        "حساب",
        "استدلال کلامی",
    ]

    const userSubscaleText = 
    [
        "درک مطلب کلامی",
        "استدلال ادراکی",
        "حافظه فعال",
        "سرعت پردازش",
        "مقیاس کل",
    ]

    const componentRef = useRef(null);

    const datesCalculator = () => {
        var birthDate = new Date(birthResult)
        var examDate = new Date(testStartDate)
        var currentDate = new Date()
        var ageDayTemp = new Date(examDate - birthDate)
        var ageMonthTemp = new Date(examDate - birthDate)
        var ageYearTemp = new Date(examDate - birthDate)
        
        setAgeDay(ageDayTemp.getDate())
        setAgeMonth(ageMonthTemp.getMonth())
        setAgeYear(ageYearTemp.getFullYear() - 1970)

        if (birthDay[0] == '۰') setBirthDay(birthDay[1])
        if (birthMonth[0] == '۰') setBirthMonth(birthMonth[1])
        if (testStartDateDay[0] == '۰') setTestStartDateDay(testStartDateDay[1])
        if (testStartDateMonth[0] == '۰') setTestStartDateMonth(testStartDateMonth[1])
    }

    useEffect (() => {
        console.log("received id in this page is:", evaluation);
        datesCalculator()
    }, [])

    var userQuestion = []
    if (testName == 'SCOBO') userQuestion = faScoboQuestions
    if (testName == 'GARS2') userQuestion = faGars2Questions
    if (testName == 'GARS3') userQuestion = faGars3Questions

    return (
        <div className='result-modal-background'>
            <div className='result-modal-container'>
                <div className='results-print' ref={componentRef}>
                    <div style={{marginTop: '0', marginBottom: '0'}} className='result-spec-table mode-text-9'>
                        <div className='result-spec-right-wrapper font-12'>
                            <div>
                                <img src={wisc4Icon1} style={{width: '100%'}}></img>
                            </div>
                            <div style={{lineHeight: '1rem'}}>
                                <p>نام آزمودنی: {name} {lName}</p>
                                <p> نام آزمونگر: {examinerName}</p>
                            </div>
                            <div>
                                <h>محاسبه سن</h>
                                <table className='w-100 mb-3' cellSpacing={0} style={{border: 'none'}}>
                                    <thead>
                                        <tr>
                                            <td style={{visibility: 'hidden'}}></td>
                                            <td>روز</td>
                                            <td>ماه</td>
                                            <td>سال</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>تاریخ اجرا</td>
                                            <td>{testStartDateDay}</td>
                                            <td>{testStartDateMonth}</td>
                                            <td>{testStartDateYear}</td>
                                        </tr>
                                        <tr>
                                            <td>تاریخ تولد</td>
                                            <td>{birthDay}</td>
                                            <td>{birthMonth}</td>
                                            <td>{birthYear}</td>
                                        </tr>
                                        <tr>
                                            <td>سن</td>
                                            <td>{farsiNumbers[ageDay]}</td>
                                            <td>{farsiNumbers[ageMonth]}</td>
                                            <td>{farsiNumbers[ageYear]}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <h>تبدیل نمرات خام به نمرات مقیاس</h>
                                <table className='w-100 mb-3' cellSpacing={0} style={{border: 'none'}}>
                                    <thead>
                                        <tr>
                                            <td>خرده آزمون</td>
                                            <td>نمرات خام</td>
                                            <td colSpan={5}>نمرات مقیاس</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='w-40'>{userPercentileText[0]}</td>
                                            <td className='w-10'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10'>{farsiNumbers[testPercentiles[0]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10'>{farsiNumbers[testPercentiles[0]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[1]}</td>
                                            <td>{}</td>
                                            <td>{farsiNumbers[testPercentiles[1]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[1]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[2]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[2]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[2]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[3]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[3]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[3]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[4]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[4]]}</td>
                                            <td>{farsiNumbers[testPercentiles[4]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[5]}</td>
                                            <td>{}</td>
                                            <td>{farsiNumbers[testPercentiles[5]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[5]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[6]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[6]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[6]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[7]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[7]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[7]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[8]}</td>
                                            <td>{}</td>
                                            <td>{farsiNumbers[testPercentiles[8]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[8]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[9]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[9]]}</td>
                                            <td>{farsiNumbers[testPercentiles[9]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[10]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[10]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[10]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[11]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[11]]}</td>
                                            <td>{farsiNumbers[testPercentiles[11]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[12]}</td>
                                            <td>{}</td>
                                            <td>{farsiNumbers[testPercentiles[12]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[12]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[13]}</td>
                                            <td>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[13]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[13]]}</td>
                                        </tr>
                                        <tr>
                                            <td>{userPercentileText[14]}</td>
                                            <td>{}</td>
                                            <td>{farsiNumbers[testPercentiles[14]]}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td className='w-10 mode-bg-12'>{}</td>
                                            <td>{farsiNumbers[testPercentiles[14]]}</td>
                                        </tr>
                                        <tr>
                                            <td style={{visibility: 'hidden'}}>{}</td>
                                            <td style={{visibility: 'hidden'}}>{}</td>
                                            <td>{farsiNumbers[testPercentiles[1] + testPercentiles[5] + testPercentiles[8]]}</td>
                                            <td>{farsiNumbers[testPercentiles[0] + testPercentiles[3] + testPercentiles[7]]}</td>
                                            <td>{farsiNumbers[testPercentiles[2] + testPercentiles[13]]}</td>
                                            <td>{farsiNumbers[testPercentiles[4] + testPercentiles[9]]}</td>
                                            <td>{farsiNumbers[testPercentiles[0] + testPercentiles[1] + testPercentiles[2] + testPercentiles[3] + testPercentiles[4] + testPercentiles[5] + testPercentiles[6] + testPercentiles[7] + testPercentiles[8] + testPercentiles[9] + testPercentiles[10] + testPercentiles[11] + testPercentiles[12] + testPercentiles[13] + testPercentiles[14]]}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <h>تبدیل نمرات مقیاس به نمرات هوشبهر</h>
                                <table className='w-100' cellSpacing={0} style={{border: 'none'}}>
                                    <thead>
                                        <tr>
                                            <td>خرده آزمون</td>
                                            <td>جمع نمرات مقیاس</td>
                                            <td>امتیاز ترکیبی</td>
                                            <td>هوشبهر</td>
                                            <td>رتبه درصدی</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{userSubscaleText[0]}</td>
                                            <td>{}</td>
                                            <td>{"VCI"}</td>
                                            <td>{farsiNumbers[testSubscales[0]]}</td>
                                            <td>{}</td>
                                        </tr>
                                        <tr>
                                            <td>{userSubscaleText[1]}</td>
                                            <td>{}</td>
                                            <td>{"PRI"}</td>
                                            <td>{farsiNumbers[testSubscales[1]]}</td>
                                            <td>{}</td>
                                        </tr>
                                        <tr>
                                            <td>{userSubscaleText[2]}</td>
                                            <td>{}</td>
                                            <td>{"WMI"}</td>
                                            <td>{farsiNumbers[testSubscales[2]]}</td>
                                            <td>{}</td>
                                        </tr>
                                        <tr>
                                            <td>{userSubscaleText[3]}</td>
                                            <td>{}</td>
                                            <td>{"PSI"}</td>
                                            <td>{farsiNumbers[testSubscales[3]]}</td>
                                            <td>{}</td>
                                        </tr>
                                        <tr>
                                            <td>{userSubscaleText[4]}</td>
                                            <td>{}</td>
                                            <td>{"FSIQ"}</td>
                                            <td>{farsiNumbers[testSubscales[4]]}</td>
                                            <td>{}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='result-spec-left-wrapper font-12'>
                            <div>
                                <img src={wisc4Icon2} style={{width: '100%'}}></img>
                            </div>
                            <div>
                                <h>پروفایل نمرات مقیاس خرده آزمون‌ها</h>
                                <table className='w-90 d-ltr' cellSpacing={0} style={{border: 'none'}}>
                                    <thead>
                                        <tr>
                                            <td colSpan={5}>درک مطلب کلامی</td>
                                            <td colSpan={4}>استدلال ادراکی</td>
                                            <td colSpan={3}>حافظه فعال</td>
                                            <td colSpan={3}>سرعت پردازش</td>
                                        </tr>
                                    </thead>
                                </table>
                                <Line className='w-100' options={options1} width={50} height={74} data={data1} plugins={[chartAreaBorder]}></Line>
                            </div>
                            <div>
                                <h>{'پروفایل نمرات هوشبهرها'}</h>
                                <table className='w-88 d-ltr' cellSpacing={0} style={{border: 'none'}}>
                                    <thead>
                                        <tr>
                                            <td>VCI</td>
                                            <td>PRI</td>
                                            <td>WMI</td>
                                            <td>PSI</td>
                                            <td>FSIQ</td>
                                        </tr>
                                        <tr>
                                            <td>{farsiNumbers[testSubscales[0]]}</td>
                                            <td>{farsiNumbers[testSubscales[1]]}</td>
                                            <td>{farsiNumbers[testSubscales[2]]}</td>
                                            <td>{farsiNumbers[testSubscales[3]]}</td>
                                            <td>{farsiNumbers[testSubscales[4]]}</td>
                                        </tr>
                                    </thead>
                                </table>
                                <Line className='w-100' options={options} width={50} height={74} data={data} plugins={[chartAreaBorder]}></Line>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '300px'}}>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart width={300} height={300}>
                                <Pie
                                    data={data}
                                    nameKey="label"
                                    dataKey="percentile"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={100}
                                    fill="#8884d8"
                                    label={renderCustomizedLabel}
                                >
                                    {data.map((color, i) => (
                                        <Cell key={`cell-${i}`} fill={COLORS[i % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </div> */}

                    {/* <div style={{marginTop: '5px'}} className='result-table'>
                    {testPercentiles.map((subCount, i) => (
                        <div className='table-result-items' key={i}>
                            <p className='result-item-title' >{userPercentileText[i]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[testPercentiles[i]]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[1]}</p>
                        </div>
                    ))}
                    </div> */}

                    {/* <div style={{marginTop: '5px'}} className='result-table'>
                    {testSubscales.map((subCount, i) => (
                        <div className='table-result-items' key={i}>
                            <p className='result-item-title' >{userSubscaleText[i]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[testSubscales[i]]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[1]}</p>
                        </div>
                    ))}
                    </div> */}
                    
                    {/* <div className='result-table'>
                        <div style={{marginTop: '10px', marginBottom: '10px'}} className='result-header mode-text-13'>
                            <div className='result-modal-title'> سوالات: </div>
                        </div>
                        {testQuestion.map((queCount, i) => (
                        <div className='table-result-items' >
                            <p className='result-item-stats'>{queCount}</p>
                            <p className='result-item-title font-12'>{userQuestion[i]}</p>
                            <p className='result-item-stats'>{testAnswer[i]}</p>
                        </div>
                        ))}
                    </div> */}
                </div>
                <div className='result-spec-table'>
                    <ReactToPrint 
                    trigger={() => <button style={{color: '#8D1D57'}}>چاپ نتایج</button>}
                    content={() => componentRef.current}
                    documentTitle= 'نتایج تست وکسلر۴'
                    />
                    <button onClick={() => closeModal(false)}>
                        متوجه شدم
                    </button>
                </div>

            </div>
            
        </div>
    )
}

export default ResultModalWisc4